import type { TaskBodyProps } from './index';
import { usePatientCard } from '../../../hooks/usePatientCard';
import { FilesTabContent } from '../../patient-files/FilesTabContent';

export function ReviewRecordsTask({ workCase: c }: TaskBodyProps) {
    const { data } = usePatientCard(c.id);
    return (
        <div className="flex-1 min-h-0 flex flex-col">
            {/* Records context: the iTero scan ID (when records are a scan) + the
          manufacturer, so the reviewer has what they need at a glance. */}
            <div className="flex items-center gap-6 px-4 py-2 border-b border-gray-100 flex-shrink-0">
                <div className="flex items-center gap-2">
                    <span className="text-[11px] font-medium text-gray-500">Scan ID</span>
                    <span className="text-sm font-semibold text-gray-800">
                        {data?.monitoring?.iteroScanId || ' - '}
                    </span>
                </div>
                <div className="flex items-center gap-2">
                    <span className="text-[11px] font-medium text-gray-500">Manufacturer</span>
                    <span className="text-sm font-semibold text-gray-800">
                        {data?.treatment?.manufacturer || ' - '}
                    </span>
                </div>
            </div>

            {/* Files UI - full feature parity with the PatientFiles page. */}
            <div className="flex-1 min-h-0 flex flex-col">
                <FilesTabContent patientId={c.id} />
            </div>
        </div>
    );
}
